export const matriculaPaises = [
  { name: 'Alemania', country_code: 'DE' },
  { name: 'Austria', country_code: 'AT' },
  { name: 'Bélgica', country_code: 'BE' },
  { name: 'Bulgaria', country_code: 'BG' },
  { name: 'Chequia', country_code: 'CZ' },
  { name: 'Croacia', country_code: 'HR' },
  { name: 'Dinamarca', country_code: 'DK' },
  { name: 'Eslovenia', country_code: 'SI' },
  { name: 'España', country_code: 'ES' },
  { name: 'Estonia', country_code: 'EE' },
  { name: 'Estados Unidos', country_code: 'US' },
  { name: 'Finlandia', country_code: 'FI' },
  { name: 'Francia', country_code: 'FR' },
  { name: 'Grecia', country_code: 'GR' },
  { name: 'Hungría', country_code: 'HU' },
  { name: 'Irlanda', country_code: 'IE' },
  { name: 'Italia', country_code: 'IT' },
  { name: 'Letonia', country_code: 'LV' },
  { name: 'Lituania', country_code: 'LT' },
  { name: 'Luxemburgo', country_code: 'LU' },
  { name: 'Países Bajos', country_code: 'NL' },
  { name: 'Polonia', country_code: 'PL' },
  { name: 'Portugal', country_code: 'PT' },
  { name: 'Reino Unido', country_code: 'GB' },
  { name: 'Rumanía', country_code: 'RO' },
  { name: 'Suecia', country_code: 'SE' },
  { name: 'Suiza', country_code: 'CH' },
];


